import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueCookies from "vue-cookies";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "./sass/app.scss";
import QuestionarioComponent from "./components/prenotazione/QuestionarioComponent";
// import * as firebase from "firebase";
import VueSocketIOExt from "vue-socket.io-extended";
import io from "socket.io-client";

const socket = io(process.env.VUE_APP_SOCKET_CONNECTION);

Vue.use(VueSocketIOExt, socket);

// const config = {
//   apiKey: "AIzaSyDgTHN02tYhz5xHy9GaE-OJAn9BGXJfjwM",
//   authDomain: "teleconsulto-1fb72.firebaseapp.com",
//   databaseURL: "https://teleconsulto-1fb72.firebaseio.com",
//   projectId: "teleconsulto-1fb72",
//   storageBucket: "teleconsulto-1fb72.appspot.com",
//   messagingSenderId: "633512329898",
//   appId: "1:633512329898:web:5db0339a82401b5df586d3",
//   measurementId: "G-EKR9LPHSH3",
// };

// firebase.initializeApp(config);
// firebase.analytics();
// try {
//   Vue.prototype.$messaging = firebase.messaging();
// } catch (error) {
//   console.log("Notifiche push non supportate su questo browser", error);
// }

Vue.component("questionario-component", QuestionarioComponent);

Vue.config.productionTip = false;

//utilizza axios ed imposta il CSRF token nell'header
Vue.prototype.$axios = axios;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.baseURL = process.env.VUE_APP_API_FULL_PATH;
axios.defaults.withCredentials = true;

//importa i component di bootstrap vue
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

//importa coockies handler
Vue.use(VueCookies);

//importa moment
// this.$moment.locale("it", it); in app
const moment = require("moment");
require("moment/locale/it");
Vue.use(require("vue-moment"), {
  moment,
});
// var socket = io.connect();

new Vue({
  router,
  store,
  data: {
    device: window.innerWidth,
  },
  render: (h) => h(App),
}).$mount("#app");
